import React from 'react'
import i18next from 'i18next'
import { FunnelIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { TwButton } from '../Button/TwButton'
import { Tooltip } from '../Tooltip/Tooltip.component'

interface FiltersButtonProps {
  activeCount: number
  onClick: () => void
  /** shows an attached ✕ segment that clears all filters without opening the drawer */
  onClear?: () => void
}

export const FiltersButton: React.FC<FiltersButtonProps> = ({ activeCount, onClick, onClear }) => {
  const isActive = activeCount > 0

  const mainButton = (
    <TwButton
      variant={isActive ? 'solid' : 'outline'}
      icon={<FunnelIcon />}
      onClick={onClick}
      className={isActive && onClear ? 'rounded-r-none' : ''}
    >
      <span className="hidden md:inline">{i18next.t('filters.button')}</span>
      {isActive && (
        <span className="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-white/25 px-1 text-xs font-semibold">
          {activeCount}
        </span>
      )}
    </TwButton>
  )

  if (!isActive || !onClear) return mainButton

  return (
    <div className="inline-flex">
      {mainButton}
      <Tooltip label={i18next.t('filters.clearAll')} align="right">
        <TwButton
          variant="solid"
          onClick={onClear}
          aria-label={i18next.t('filters.clearAll')}
          className="-ml-px rounded-l-none border-l-indigo-400"
          icon={<XMarkIcon />}
        />
      </Tooltip>
    </div>
  )
}
